// extracted by mini-css-extract-plugin
export default {"mainContainer":"BlogContent_mainContainer__pK9Si","blogContainer":"BlogContent_blogContainer__UGhHY","blogLink":"BlogContent_blogLink__Oquuw"};